import { useSelector } from 'react-redux';
import { useLocation, Navigate } from 'react-router-dom';

const RoleGuard = ({ children }) => {
    const location = useLocation();
    const currentRole = useSelector((state) => state.auth.Role);

    console.log('RoleGuard - Current role:', currentRole);
    console.log('RoleGuard - Current path:', location.pathname);

    if(currentRole === 'Admin' && !location.pathname.startsWith('/Admin')) {
       console.log('RoleGuard - Redirecting Admin to /Admin');
       return <Navigate to="/Admin" replace />;
    }

    if((currentRole === 'Free_User' || currentRole === 'Pro_User' || currentRole === 'Demo_User') && !location.pathname.startsWith('/User')) {
        console.log('RoleGuard - Redirecting User to /User');
        return <Navigate to="/User" replace />;
    }

    if(currentRole === 'Moderator' && !location.pathname.startsWith('/Moderator')) {
        console.log('RoleGuard - Redirecting Moderator to /Moderator');
        return <Navigate to="/Moderator" replace />;
    }

    return children;
}

export default RoleGuard;